var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpheres = function SvgSpheres(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 55.64c0 10.678-8.656 19.334-19.333 19.334-10.678 0-19.334-8.656-19.334-19.334 0-10.677 8.656-19.333 19.334-19.333C34.344 36.307 43 44.963 43 55.64Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.333 55.64c0 10.678-8.656 19.334-19.333 19.334-10.678 0-19.333-8.656-19.333-19.334 0-10.677 8.655-19.333 19.333-19.333 10.677 0 19.333 8.656 19.333 19.333Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.444 26.307c0 10.677-8.655 19.333-19.333 19.333-10.677 0-19.333-8.656-19.333-19.333 0-10.677 8.656-19.333 19.333-19.333 10.678 0 19.333 8.655 19.333 19.333Z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 40.333,
    y1: 6.974,
    x2: 40.333,
    y2: 74.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DD6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.333,
    y1: 6.974,
    x2: 40.333,
    y2: 74.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 40.111,
    y1: 9.64,
    x2: 40.111,
    y2: 48.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7",
    stopOpacity: 0.2
  })))));
};

export { SvgSpheres as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODEiIGhlaWdodD0iODEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQzIDU1LjY0YzAgMTAuNjc4LTguNjU2IDE5LjMzNC0xOS4zMzMgMTkuMzM0LTEwLjY3OCAwLTE5LjMzNC04LjY1Ni0xOS4zMzQtMTkuMzM0IDAtMTAuNjc3IDguNjU2LTE5LjMzMyAxOS4zMzQtMTkuMzMzQzM0LjM0NCAzNi4zMDcgNDMgNDQuOTYzIDQzIDU1LjY0WiIgZmlsbD0idXJsKCNhKSIvPjxwYXRoIGQ9Ik03Ni4zMzMgNTUuNjRjMCAxMC42NzgtOC42NTYgMTkuMzM0LTE5LjMzMyAxOS4zMzQtMTAuNjc4IDAtMTkuMzMzLTguNjU2LTE5LjMzMy0xOS4zMzQgMC0xMC42NzcgOC42NTUtMTkuMzMzIDE5LjMzMy0xOS4zMzMgMTAuNjc3IDAgMTkuMzMzIDguNjU2IDE5LjMzMyAxOS4zMzNaIiBmaWxsPSJ1cmwoI2IpIi8+PHBhdGggZD0iTTU5LjQ0NCAyNi4zMDdjMCAxMC42NzctOC42NTUgMTkuMzMzLTE5LjMzMyAxOS4zMzMtMTAuNjc3IDAtMTkuMzMzLTguNjU2LTE5LjMzMy0xOS4zMzMgMC0xMC42NzcgOC42NTYtMTkuMzMzIDE5LjMzMy0xOS4zMzMgMTAuNjc4IDAgMTkuMzMzIDguNjU1IDE5LjMzMyAxOS4zMzNaIiBmaWxsPSJ1cmwoI2MpIi8+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNDAuMzMzIiB5MT0iNi45NzQiIHgyPSI0MC4zMzMiIHkyPSI3NC45NzQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjOTQ1REQ2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOTQ1REQ2IiBzdG9wLW9wYWNpdHk9Ii4yIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSI0MC4zMzMiIHkxPSI2Ljk3NCIgeDI9IjQwLjMzMyIgeTI9Ijc0Ljk3NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiNGNDY4MzciLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGNDY4MzciIHN0b3Atb3BhY2l0eT0iLjIiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYyIgeDE9IjQwLjExMSIgeTE9IjkuNjQiIHgyPSI0MC4xMTEiIHkyPSI0OC4zMDciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjMTNBREM3Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTNBREM3IiBzdG9wLW9wYWNpdHk9Ii4yIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PC9zdmc+";